import * as React from "react"
import { Box, Typography, Chip } from "@mui/material"
import { ImageSeeker, IconSeeker } from "@ui-seeker/core"


export default function ProductOption({ product, isSelected, isSaving, onSelect, onImageClick }) {
    const handleImageClick = (e) => {
        e.stopPropagation()
        if (onImageClick && !isSaving) {
            onImageClick()
        }
    }

    return (
        <Box
            onClick={isSaving ? undefined : onSelect}
            sx={{
                display: 'flex',
                gap: 2,
                p: 1.5,
                border: isSelected ? '3px solid' : '1px solid',
                borderColor: isSelected ? 'success.main' : '#e5e7eb',
                borderRadius: 1,
                cursor: isSaving ? 'wait' : 'pointer',
                backgroundColor: isSelected ? '#ecfdf5' : '#fff',
                opacity: isSaving ? 0.7 : 1,
                transition: 'all 0.2s',
                '&:hover': {
                    borderColor: isSaving ? undefined : 'primary.light',
                    backgroundColor: isSaving ? undefined : (isSelected ? '#ecfdf5' : '#f9fafb')
                }
            }}
        >
            <Box sx={{ display: 'flex', alignItems: 'center', width: 24 }}>
                {isSelected ? (
                    <IconSeeker icon="square-check" sx={{ color: 'success.main', fontSize: 20 }} />
                ) : (
                    <Box sx={{
                        width: 18,
                        height: 18,
                        border: '2px solid #d1d5db',
                        borderRadius: '3px',
                        '&:hover': { borderColor: 'primary.main' }
                    }} />
                )}
            </Box>

            <Box
                sx={{
                    width: 60,
                    height: 60,
                    flexShrink: 0,
                    cursor: 'zoom-in',
                    '&:hover': { opacity: 0.8 }
                }}
                onClick={handleImageClick}
            >
                <ImageSeeker
                    useSpinner
                    lazyLoad={false}
                    src={product.thumbnail}
                    sx={{
                        width: 60,
                        height: 60,
                        borderRadius: 1,
                        border: '1px solid #e5e7eb',
                        objectFit: 'contain',
                        backgroundColor: '#fff'
                    }}
                />
            </Box>

            <Box sx={{ flex: 1, minWidth: 0 }}>
                <Typography variant="body2" sx={{ fontWeight: 600, mb: 0.5 }}>
                    {product.productTitle}
                </Typography>

                {product.variant && (
                    <Typography variant="caption" color="text.secondary" display="block">
                        Variant: {product.variant}
                    </Typography>
                )}

                {product.actualPrice != null && (
                    <Typography variant="caption" color="text.secondary" display="block">
                        Price: {product.actualPrice} {product.currency || ''}
                    </Typography>
                )}

                <Box sx={{ display: 'flex', gap: 0.5, mt: 1, flexWrap: 'wrap' }}>
                    <Chip
                        label={`ID: ${product.productID}`}
                        size="small"
                        variant="outlined"
                        sx={{ fontSize: '0.65rem', height: 18 }}
                    />
                    {product.alreadyMapped && (
                        <Chip
                            label="Already Mapped"
                            size="small"
                            sx={{ fontSize: '0.65rem', height: 18, backgroundColor: '#fef3c7', color: '#92400e' }}
                        />
                    )}
                </Box>
            </Box>
        </Box>
    )
}
